import { dataelementAPI } from 'api/dataelement';
import { DataelementDto } from 'dto/dataelement';
import { useQuery } from 'react-query';
import { QUERY_KEY } from 'utils/enums';

type PropsType = {
  id: number;
  enabled?: boolean;
  onSuccess?: (data: DataelementDto) => void;
};

export function useFindOneDataelement(props: PropsType) {
  const query = useQuery({
    queryKey: [QUERY_KEY.FIND_ONE_DATAELEMENT, props.id],
    queryFn: () => dataelementAPI.findOne(props.id),
    enabled: !!props.id || props.enabled,
    onSuccess: props.onSuccess,
  });

  return query;
}
